import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Translation } from '@ngneat/transloco';
import { BaseHrefService } from '@nibtravel/shared/util/base-href';
import { Observable } from 'rxjs';

import { Resolver } from '../types';

@Injectable({ providedIn: 'root' })
export class DefaultHttpResolver implements Resolver {
  constructor(
    private hrefService: BaseHrefService,
    private httpClient: HttpClient
  ) {}

  public load(lang: string, scope?: string): Observable<Translation> {
    const url = scope
      ? `${this.hrefService.translation}/${scope}/${lang}.json`
      : `${this.hrefService.translation}/${lang}.json`;

    return this.httpClient.get<Translation>(url);
  }
}
